import { render } from "./LiveDemoExportDialog.vue?vue&type=template&id=6126d244"
import script from "./LiveDemoExportDialog.vue?vue&type=script&lang=js"
export * from "./LiveDemoExportDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__